import CountryForm from '../../components/CountryForm/CountryForm';
import { CREATE_COUNTRY } from '../../constants';

function CountryCreation() {
  return <CountryForm type={CREATE_COUNTRY} />;
}

export default CountryCreation;
